import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
export function createAppRouter() {
  return createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes: [
      { path: '/', name: 'home', component: () => import('./pages/HomePage.vue') },
      { path: '/about', name: 'about', component: () => import('./pages/AboutPage.vue') },
      { path: '/services', name: 'services', component: () => import('./pages/ServicesPage.vue') },
      { path: '/services/:slug', name: 'service-detail', component: () => import('./pages/ServiceDetailPage.vue') },
      { path: '/works', name: 'works', component: () => import('./pages/WorksPage.vue') },
      { path: '/works/:slug', name: 'work-detail', component: () => import('./pages/WorkDetailPage.vue') },
      { path: '/news', name: 'news', component: () => import('./pages/NewsPage.vue') },
      { path: '/news/:slug', name: 'news-detail', component: () => import('./pages/NewsDetailPage.vue') },
      { path: '/contact', name: 'contact', component: () => import('./pages/ContactPage.vue') },
      { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('./pages/NotFoundPage.vue') },
    ],
  })
}
